import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, message } from "antd";
import { MailOutlined, DeleteOutlined } from "@ant-design/icons";
import Logo from "../../asset/images/logo.png";
import "./styles.scss";

const { Title, Text, Paragraph } = Typography;

interface DeleteAccountFormData {
  email: string;
}

const DeleteAccountScreen: React.FC = () => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onFinish = async (values: DeleteAccountFormData) => {
    setIsLoading(true);

    try {
      // Simulate API call delay
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setIsSubmitted(true);
      message.success("Account deletion request submitted successfully");
    } catch (error) {
      message.error("Failed to submit request. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="auth-container">
        <Card className="auth-card">
          <div className="auth-header">
            <img src={Logo} style={{ height: "35px", marginBottom: "10px" }} />
            <br />
            <Text className="auth-subtitle">
              Your request has been submitted to admin for confirmation.
            </Text>
          </div>

          <Form className="auth-form">
            <Form.Item className="auth-submit">
              <Button
                type="primary"
                block
                className="auth-button"
                style={{ borderRadius: "0px" }}
                onClick={() => (window.location.href = "/")}
              >
                Return to Home
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <Card className="auth-card">
        <div className="auth-header">
          <img src={Logo} style={{ height: "35px", marginBottom: "10px" }} />
          <br />
          <Text className="auth-subtitle">Delete Account</Text>
        </div>

        <div className="instructions-text">
          <Text>Account Deletion Instructions:</Text>
          <ul>
            <li>
              Once you submit this request, your account will be reviewed by our
              admin team
            </li>
            <li>
              You will receive a confirmation email within 2-3 business days
            </li>
            <li>
              All your personal data will be permanently removed from our
              systems
            </li>
            <li>This action cannot be undone once approved</li>
            <li>You will lose access to all your saved preferences and data</li>
          </ul>
        </div>

        <Form
          form={form}
          name="deleteAccount"
          onFinish={onFinish}
          layout="vertical"
          size="middle"
          className="auth-form"
        >
          <Form.Item
            name="email"
            label="Email Address"
            rules={[
              {
                required: true,
                message: "Please enter your email address",
              },
              {
                type: "email",
                message: "Please enter a valid email address",
              },
            ]}
          >
            <Input
              style={{ borderRadius: "0px" }}
              placeholder="Enter your email address"
            />
          </Form.Item>

          <Form.Item className="auth-submit">
            <Button
              style={{ borderRadius: "0px" }}
              type="primary"
              htmlType="submit"
              loading={isLoading}
              block
              className="auth-button"
            >
              {isLoading ? "Submitting Request..." : "Submit Deletion Request"}
            </Button>
          </Form.Item>
        </Form>

        <div className="auth-footer">
          <Text>
            Once you submit this request, your account will be reviewed by our
            admin team. You will receive a confirmation email within 2-3
            business days.
          </Text>
        </div>
      </Card>
    </div>
  );
};

export default DeleteAccountScreen;
